import React from "react";
import { Navbar } from "../../components/NavbarSimple";
import Footer from "../../components/Footer";
import Grid from "@mui/material/Grid";
//import { urlRoot, eventRoot } from "../../global";

/**
 * Mapeo de slugs de campus de prepa a la ciudad de tec.mx correspondiente.
 * Campus profesionales usan su propio slug directamente.
 */
const PREPA_CAMPUS_MAP = {
  // Guadalajara
  "santa-anita": "guadalajara",
  "santaanita": "guadalajara",
  // Chiapas → Monterrey
  "chiapas": "monterrey",
  // Monterrey (varios campus de prepa)
  "cumbres": "monterrey",
  "eugenio-garza-sada": "monterrey",
  "eugenio-garza-laguera": "monterrey",
  "eugenio-garza-lag-era": "monterrey",
  "valle-alto": "monterrey",
  "navojoa": "monterrey",
  "santa-catarina": "monterrey",
  // Ciudad de México
  "esmeralda": "ciudad-de-mexico",
};

/**
 * Dada el slug del campus, devuelve la URL completa de tec.mx correspondiente.
 * Para campus de prepa aplica las reglas especiales; para los demás usa el slug directo.
 * Fallback: monterrey.
 */
function getTecMxUrl(campusSlug) {
  if (!campusSlug) return "https://tec.mx/es/monterrey#eventos-y-comunidad";

  const slug = campusSlug.toLowerCase().trim();

  // Revisar si es un campus de prepa con regla especial
  if (PREPA_CAMPUS_MAP[slug]) {
    return `https://tec.mx/es/${PREPA_CAMPUS_MAP[slug]}#eventos-y-comunidad`;
  }

  // Para campus profesionales usar el slug directamente
  const SLUG_CORRECTIONS = {
    "cdmx": "ciudad-de-mexico",
    "ciudad-de-mexico": "ciudad-de-mexico",
    "ciudad-juarez": "ciudad-juarez",
    "ciudad-obregon": "ciudad-obregon",
    "estado-de-mexico": "estado-de-mexico",
    "guadalajara": "guadalajara",
    "laguna": "laguna",
    "leon": "leon",
    "monterrey": "monterrey",
    "morelia": "morelia",
    "puebla": "puebla",
    "queretaro": "queretaro",
    "saltillo": "saltillo",
    "san-luis-potosi": "san-luis-potosi",
    "santa-fe": "santa-fe",
    "sinaloa": "sinaloa",
    "sonora-norte": "sonora-norte",
    "tampico": "tampico",
    "toluca": "toluca",
    "zacatecas": "zacatecas",
  };

  const correctedSlug = SLUG_CORRECTIONS[slug] || slug;

  if (!correctedSlug) return "https://tec.mx/es/monterrey#eventos-y-comunidad";

  return `https://tec.mx/es/${correctedSlug}#eventos-y-comunidad`;
}

function Gracias() {
  const campusSlug = localStorage.getItem("campusSlugGracias");
  const tecMxUrl = getTecMxUrl(campusSlug);

  return (
    <div>
      <Navbar tituloEvento="Gracias por registrarte" nivel="profesional" />
      <Grid container spacing={4} sx={{ mt: 8, mb: 10, textAlign: "center", minHeight: "50vh" }}>
        <Grid item xs={1} md={3}></Grid>
        <Grid item xs={10} md={6}>
          <h1 style={{ color: "#109AFF", fontSize: "2.5rem", marginBottom: "2rem" }}>
            ¡Gracias por tu registro!
          </h1>
          <p style={{ fontSize: "1.2rem", color: "#666" }}>
            Te hemos enviado un correo de confirmación con los detalles del evento.
          </p>
          <p style={{ fontSize: "1.2rem", color: "#666", marginTop: "2rem" }}>
            Te sugerimos seguir explorando{" "}
            <a href={tecMxUrl} style={{ color: "#109AFF", fontWeight: "bold", textDecoration: "none" }}>
              nuestros otros eventos disponibles
            </a>
            . ¡Esperamos verte pronto!
          </p>
        </Grid>
        <Grid item xs={1} md={3}></Grid>
      </Grid>
      <div style={{ marginTop: "5%", height: "1px" }}>
        <Footer />
      </div>
    </div>
  );
}

export default Gracias;
